import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'

interface StyledInnerTextWrapperProps
  extends Pick<TOITeaserLayoutContextType, 'articleType' | 'teaserFlex'> {
  alignment: TOITeaserLayoutContextType['mainTextAlignment']['h']
}

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledInnerTextWrapper = styled.div<StyledInnerTextWrapperProps>`
  ${({ teaserFlex, alignment, articleType }) => {
    const desktopTeaserFlex = teaserFlex['desktop']
    const desktopCornerPadding =
      desktopTeaserFlex === '6'
        ? '16px'
        : desktopTeaserFlex === '4'
        ? '16px'
        : desktopTeaserFlex === '3'
        ? '12px'
        : desktopTeaserFlex === '2'
        ? '8px'
        : '0px'
    const desktopOppositeSidePadding =
      desktopTeaserFlex === '6'
        ? '-8px'
        : desktopTeaserFlex === '4'
        ? '8px'
        : desktopTeaserFlex === '3'
        ? '4px'
        : desktopTeaserFlex === '2'
        ? '4px'
        : '0px'

    const tabletTeaserFlex = teaserFlex['tablet']
    const tabletCornerPadding =
      tabletTeaserFlex === '6'
        ? '16px'
        : tabletTeaserFlex === '3'
        ? '12px'
        : '0px'
    const tabletOppositeSidePadding =
      tabletTeaserFlex === '6'
        ? '8px'
        : tabletTeaserFlex === '3'
        ? '4px'
        : '0px'

    const mobileCornerPadding = '3vw'
    const mobileOppositeSidePadding = '1.5vw'

    return css`
      text-align: ${alignment};
      position: relative;
      width: 100%;
      box-sizing: border-box;
      ${articleType !== 'default' &&
      css`
        height: 100%;
      `};

      ${desktopCSS(css`
       padding-${alignment}: calc(${desktopCornerPadding} + 8px);
       padding-${
         alignment === 'left' ? 'right' : 'left'
       }: calc(${desktopOppositeSidePadding} + 8px);
      `)}

      ${tabletCSS(css`
       padding-${alignment}: calc(${tabletCornerPadding} + 8px);
       padding-${
         alignment === 'left' ? 'right' : 'left'
       }: calc(${tabletOppositeSidePadding} + 8px);
      `)}

      
      ${mobileCSS(css`
       padding-${alignment}: calc(${mobileCornerPadding} + 8px);
       padding-${
         alignment === 'left' ? 'right' : 'left'
       }: calc(${mobileOppositeSidePadding} + 8px);
      `)}
    `
  }}
`

const InnerTextWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { teaserFlex, mainTextAlignment, articleType } = useContext(
    TOITeaserLayoutContext
  )

  return (
    <StyledInnerTextWrapper
      teaserFlex={teaserFlex}
      alignment={mainTextAlignment['h']}
      articleType={articleType}>
      {children}
    </StyledInnerTextWrapper>
  )
}

export default InnerTextWrapper
